<template>
  <span class="tag indicator-status-tag has-text-weight-medium" :class="[color || defaultColor]">
    {{ label }}
    <b-icon :pack="icon.pack" :icon="icon.name" size="is-medium" class="ml-4px" />
  </span>
</template>

<script>
import EnumHelper from '@/helpers/enums'
import {
  INDICATOR_STATUS_TODO,
  INDICATOR_STATUS_IN_PROGRESS,
  INDICATOR_STATUS_DONE,
  INDICATOR_STATUS_NOT_APPLICABLE
} from '@/consts/enums'

export default {
  props: {
    status: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    }
  },
  computed: {
    label() {
      return EnumHelper.formatIndicatorStatus(this.status)
    },
    defaultColor() {
      switch (this.status) {
        case INDICATOR_STATUS_TODO:
          return 'indicator-status-tag--yellow'
        case INDICATOR_STATUS_IN_PROGRESS:
          return 'indicator-status-tag--blue'
        case INDICATOR_STATUS_DONE:
          return 'indicator-status-tag--green'
        case INDICATOR_STATUS_NOT_APPLICABLE:
          return 'indicator-status-tag--grey'
        default:
          return ''
      }
    },
    icon() {
      switch (this.status) {
        case INDICATOR_STATUS_TODO:
          return { name: 'eye', pack: 'far' }
        case INDICATOR_STATUS_IN_PROGRESS:
          return { name: 'circle', pack: 'far' }
        case INDICATOR_STATUS_DONE:
          return { name: 'check', pack: 'fas' }
        case INDICATOR_STATUS_NOT_APPLICABLE:
          return { name: 'ban', pack: 'fas' }
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.indicator-status-tag {
  font-size: 14px;

  &--blue {
    background-color: $pale-blue;
    color: $blue;
  }

  &--green {
    background-color: $pale-green;
    color: $green;
  }

  &--red {
    background-color: $white;
    color: $red;
    border: 1px solid $red;
  }

  &--yellow {
    background-color: $white;
    color: $yellow;
    border: 1px solid $yellow;
  }

  &--grey {
    background-color: $white-bis;
    color: $grey;
  }
}
</style>